import React from 'react';

const HomePage = () => {
  return <h1>Our Home!</h1>;
};

export default HomePage;
